import { Button, ButtonGroup, Dialog, DialogContent, Divider, TextField, Typography } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { pettyCashApiNm, pettyCashColNm } from "./constant"
import PayComponent from "./PayComponent"
import { initReimbursementDialogData } from "./initData"
import { UserContext } from "contexts/UserContext"
import { alertConfirmDelete, alertError } from "components/Alert"
import dayjs from "dayjs"
import { DesktopDatePicker } from "@mui/x-date-pickers-pro"

let suggestUsrAccIds = []
const ReimbursementDialog = ({ dialogOpen, setDialogOpen, onFinish, getFn, getArgs, isFromJobOrder
  , joData, usrAccId, pcItmData, pcItmId, updLnkSiteAbbr }) => {

  const { user } = useContext(UserContext)
  const { ax, msData } = useContext(GlobalStateContext)
  const [dialogData, setDialogData] = useState({ ...initReimbursementDialogData })

  const initReimbursementDialogDataMemo = useMemo(() => ({
    ...initReimbursementDialogData,
    PCJnlId: msData.pcJournalCombo.find(item => item.IsDf)?.id || null
  })
    , [msData.pcJournalCombo])

  const textFieldProps = useCallback((name) => ({
    label: pettyCashColNm[name],
    size: "small",
    value: dialogData[name],
    onChange: (e) => setDialogData(o => ({ ...o, [name]: e.target.value })),
  }), [dialogData])

  const dateTimePickerProp = useCallback((name) => ({
    label: pettyCashColNm[name],
    inputFormat: "DD/MM/YYYY",
    mask: "__/__/____",
    value: dialogData[name],
    onChange: (newValue) => { setDialogData(o => ({ ...o, [name]: newValue })) },
    renderInput: (params) => <TextField size="small" {...params} />,
  }), [dialogData])

  const handleDialogOk = useCallback(() => {

    if (!dialogData.Amnt || !dialogData.UsrAccId || !dialogData.ExpId || !dialogData.PayTm || !dialogData.PCJnlId) {
      alertError("กรุณากรอกข้อมูลให้ครบถ้วน")
      return
    }
    if(!dayjs(dialogData.PayTm).isValid() || (dialogData.DocDte && !dayjs(dialogData.DocDte).isValid())){
      alertError("รูปแบบวันที่ไม่ถูกต้อง")
      return
    }
    const postData = {
      transactionArgs: {
        ...dialogData,
        AdmAccId: user.AccId,
        isReimbursement: true,
      },
      itemArgs: {
        ...dialogData,
        InOutTypItm: dialogData.InOutTyp,
        AdmAccId: user.AccId,
        PCItmTm: dialogData.PayTm,
        Rmk: dialogData.ReimRmk,
        isReimbursement: true,
      },
      UpdLnkSiteAbbr: updLnkSiteAbbr,
    }
    if (isFromJobOrder) {
      const resturnData = {
        ...postData.itemArgs,
        canRemove: true,
        UsrNNm: msData.accountAllCombo.find(acc => acc.id === dialogData.UsrAccId)?.label || "",
        ExpNm: msData.expObj[dialogData.ExpId]?.ExpNm || "",
        postData: postData
      }
      onFinish(resturnData)
      setDialogOpen(false)
    } else {
      postData.getFn = getFn
      postData.getArgs = getArgs
      const apiNm = pcItmId ? pettyCashApiNm.updateReimbursment : pettyCashApiNm.insertReimbursment
      ax.post(apiNm, postData).then(value => {
        if (value.data) {
          onFinish(value.data)
          setDialogOpen(false)
        }
      })
    }
  }, [ax, dialogData, onFinish, setDialogOpen, getFn, getArgs, user.AccId, isFromJobOrder, msData.accountAllCombo
    , msData.expObj, pcItmId, updLnkSiteAbbr])

  const handleDelete = useCallback(() => {
    alertConfirmDelete(() => {
      ax.post(pettyCashApiNm.deletePCTransaction, { PCTrnsId: dialogData.PCTrnsId, UpdLnkSiteAbbr: updLnkSiteAbbr }).then(value => {
        if (value.data) {
          onFinish()
          setDialogOpen(false)
        }
      })
    })

  }, [ax, dialogData.PCTrnsId, onFinish, setDialogOpen, updLnkSiteAbbr])


  const handleDocNoBlur = useCallback((e) => {
    // console.log("checkDocNoExist e.target.value:: ", e.target.value);
    if(!e.target.value) return
    ax.post(pettyCashApiNm.checkDocNoExist, { DocNo: e.target.value }, false).then(value => {
      if (value.data) {
        if (value.data.length > 0) {
          alertError(`เลขที่เอกสาร ${e.target.value} มีอยู่ในระบบแล้ว กรุณาตรวจสอบ`)
        }
      }
    })
  }, [ax])

  useEffect(() => {
    if (dialogOpen) {
      if (pcItmId) {
        ax.post(pettyCashApiNm.getReimbursementData, { PCItmId: pcItmId, UpdLnkSiteAbbr: updLnkSiteAbbr }).then(value => {
          if (value.data) {
            setDialogData(value.data)
          }
        })
      } else {
        if (joData) {
          if (joData.ContStses && joData.ContStses.length > 0) {
            suggestUsrAccIds = joData.ContStses.map(item => item.DrvId)
          }

          if (pcItmData) {
            setDialogData({ ...pcItmData, PayTm: dayjs().format("YYYY-MM-DD HH:mm:ss") })
          } else {

            const takePlc = msData.poiObj[joData.TakePOIId] || ""
            const loc = msData.poiObj[joData.LocPOIId] || ""
            const rtnPlc = msData.poiObj[joData.RtnPOIId] || ""
            setDialogData({
              ...initReimbursementDialogDataMemo,
              JobOrdId: joData.JobOrdId,
              UsrAccId: usrAccId,
              LocText: `(${joData.ContSizeFull || ""})${takePlc}-${loc}-${rtnPlc}`,
              PayTm: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            })
          }
        } else if (usrAccId) {
          setDialogData({
            ...initReimbursementDialogDataMemo,
            UsrAccId: usrAccId,
            PayTm: dayjs().format("YYYY-MM-DD HH:mm:ss"),
          })
        }
      }
    } else {
      setDialogData({
        ...initReimbursementDialogDataMemo
        , PayTm: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        UsrAccId: usrAccId,
      })
    }
  }, [dialogOpen, ax, initReimbursementDialogDataMemo, joData, usrAccId, pcItmData
    , msData.poiObj, pcItmId, updLnkSiteAbbr])

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='md'
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="เบิกตามใบเสร็จ"
        onDeleteClick={dialogData.PCTrnsId ? handleDelete : null}
      />
      <DialogContent>
        <BoxFR pt={2} sx={{ alignItems: "stretch", justifyContent: "center", gap: 2 }}>
          <BoxFC width={400} sx={{ gap: 1 }}>
            <BoxFR width="100%" justifyContent="center">
              <ButtonGroup sx={{ width: "100%" }}>
                <Button fullWidth variant={dialogData.InOutTyp === "O" ? "contained" : "outlined"}
                  onClick={() => { setDialogData(o => ({ ...o, InOutTyp: "O", IsCost: 1 })) }}>จ่ายเงิน</Button>
                <Button fullWidth variant={dialogData.InOutTyp === "I" ? "contained" : "outlined"}
                  onClick={() => { setDialogData(o => ({ ...o, InOutTyp: "I", IsCost: 1 })) }}>รับเงิน</Button>
              </ButtonGroup>
            </BoxFR>
            <PayComponent
              updLnkSiteAbbr={updLnkSiteAbbr}
              dialogOpen={dialogOpen}
              dialogData={dialogData}
              setDialogData={setDialogData}
              isRequriedUsrAccId={true}
              usrAccId={usrAccId}
              jobOrdId={joData?.JobOrdId}
              suggestUsrAccIds={suggestUsrAccIds} />
          </BoxFC>
          <Divider orientation="vertical" variant="middle" sx={{ height: 240, alignSelf: "center" }} flexItem />
          <BoxFC width={250} sx={{ gap: 1 }}>
            <Typography sx={{ pl: 1 }} fontWeight="bold">ใบเสร็จ-การใช้เงิน</Typography>
            <TextField {...textFieldProps("DocNo")} onBlur={handleDocNoBlur} />
            <DesktopDatePicker {...dateTimePickerProp("DocDte")} />
            {/* <TextField {...textFieldProps("ReimDscp")} /> */}
            <TextField {...textFieldProps("ReimRmk")} />
          </BoxFC>
        </BoxFR>

      </DialogContent>
      <DialogFooter okText="บันทึก"
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleDialogOk} />
    </Dialog>
  )
}

export default React.memo(ReimbursementDialog)